import delhi from '../../assets/tourpackage/1.png';
import udaipur from '../../assets/tourpackage/3.png';
import Agra from '../../assets/tourpackage/8.png';
import mumbai from '../../assets/tourpackage/mumbai.png'
import bikaner from '../../assets/taxiService/bikaner.jpg'
import jodhpur from '../../assets/taxiService/jodhpur.jpg'
import kota from '../../assets/taxiService/kota.jpg'
import Gurgaon from '../../assets/taxiService/Gurgaon.jpg'
import noida from '../../assets/taxiService/noida.jpg'
import Ajmer from '../../assets/taxiService/ajmer.jpg'
import Pushkar from '../../assets/taxiService/pushkar.jpg'
import Ahmedabad from '../../assets/taxiService/ahmedabad.jpg'
import Chandigarh from '../../assets/taxiService/chandigar.jpg'

const TaxiServiceData = [
    {
        id: 0,
        city: "Delhi",
        img: delhi,
        description:
            "Looking for the best taxi service in Delhi? We provide affordable and reliable one-way taxi from Delhi and round-trip cabs to top destinations across North India. Our fleet includes clean sedans, SUVs, and tempo travellers suitable for solo, family, and group travel. With 24/7 availability, transparent fares, and trained drivers, your journey will always be safe and comfortable. Book your Delhi taxi online with instant confirmation.",
        popularRoutes: [
            "Delhi to Agra",
            "Delhi to Jaipur",
            "Delhi to Chandigarh",
            "Delhi to Gurgaon",
            "Delhi to Noida",
            "Delhi to Mathura"
        ]
    },
    {
        id: 1,
        city: "Bikaner",
        img: bikaner,
        description:
            "Book top-rated Bikaner taxi services for local and outstation travel. We offer one-way taxi from Bikaner and round-trip cab services to nearby cities at competitive rates. Whether you're a tourist exploring Rajasthan or a resident traveling for work, our taxis are perfect for all your needs. Enjoy a stress-free journey with professional drivers and on-time pickup. Now book your Bikaner cab online within minutes.",
        popularRoutes: [
            "Bikaner to Jodhpur",
            "Bikaner to Jaipur",
            "Bikaner to Udaipur",
            "Bikaner to Delhi",
            "Bikaner to Mount Abu",
            "Bikaner to Ajmer"
        ]
    },
    {
        id: 2,
        city: "Udaipur",
        img: udaipur,
        description:
            "Travel smart with our premium taxi services in Udaipur offering one-way and round-trip taxis to Rajasthan and Gujarat cities. Whether you need an airport transfer, day trip, or outstation ride, we’ve got you covered. Our professional drivers and well-maintained vehicles ensure a smooth travel experience. Book your Udaipur cab service now for an affordable and safe ride.",
        popularRoutes: [
            "Udaipur to Mount Abu",
            "Udaipur to Ahmedabad",
            "Udaipur to Jaipur",
            "Udaipur to Jodhpur",
            "Udaipur to Ajmer",
            "Udaipur to Delhi"
        ]
    },
    {
        id: 3,
        city: "Jodhpur",
        img: jodhpur,
        description:
            "Looking for affordable Jodhpur taxi service for one-way or round-trip journeys? We offer reliable intercity cab services from Jodhpur to Jaipur, Udaipur, Bikaner, and more. Our cabs come with trained drivers, transparent fares, and real-time tracking. Whether you're traveling for leisure or business, book your Jodhpur cab online and experience hassle-free rides.",
        popularRoutes: [
            "Jodhpur to Jaipur",
            "Jodhpur to Udaipur",
            "Jodhpur to Bikaner",
            "Jodhpur to Delhi",
            "Jodhpur to Ajmer",
            "Jodhpur to Kishangarh"
        ]
    },
    {
        id: 4,
        city: "Kota",
        img: kota,
        description:
            "Book your Kota taxi service for convenient travel within Rajasthan and beyond. We provide one-way and return cabs from Kota to Delhi, Jaipur, and other major cities. Our experienced drivers, flexible timings, and fair pricing make us the preferred choice for families, students, and business travelers. Experience the comfort of door-to-door service with our Kota cab booking platform.",
        popularRoutes: [
            "Kota to Jaipur",
            "Kota to Udaipur",
            "Kota to Mount Abu",
            "Kota to Delhi",
            "Kota to Agra",
            "Kota to Indore"
        ]
    },
    {
        id: 5,
        city: "Agra",
        img: Agra,
        description:
            "Book affordable Agra taxi services with our trusted one-way and round-trip cab options. Whether you're planning a weekend escape from the city or need a pick-up for an airport transfer, our taxis ensure a comfortable journey. We cover top tourist and business hubs with safe and timely rides. Get your Agra to Delhi taxi or any other route confirmed in just a few clicks.",
        popularRoutes: [
            "Agra to Delhi",
            "Agra to Jaipur",
            "Agra to Noida",
            "Agra to Gurgaon",
            "Agra to Mathura",
            "Agra to Mumbai"
        ]
    },
    {
        id: 6,
        city: "Gurgaon",
        img: Gurgaon,
        description:
            "Looking for a reliable taxi service in Gurgaon? We offer easy and quick Gurgaon one-way taxi and round-trip bookings for local and outstation travel. Whether it's an airport drop, business meeting, or holiday trip, our taxi services ensure comfort and punctuality. Our fleet includes AC cabs, SUVs, and tempo travellers. Book your Gurgaon cab service now and travel worry-free.",
        popularRoutes: [
            "Gurgaon to Delhi",
            "Gurgaon to Agra",
            "Gurgaon to Jaipur",
            "Gurgaon to Chandigarh",
            "Gurgaon to Noida",
            "Gurgaon to Mathura"
        ]
    },
    {
        id: 7,
        city: "Noida",
        img: noida,
        description:
            "Experience smooth and budget-friendly travel with our Noida taxi service. We provide one-way cabs from Noida and return trip options to nearby cities like Delhi, Jaipur, and Agra. From airport transfers to family trips, our clean vehicles and professional drivers make your journey pleasant. Plan your outstation travel today with our Noida cab booking facility.",
        popularRoutes: [
            "Noida to Delhi",
            "Noida to Agra",
            "Noida to Jaipur",
            "Noida to Chandigarh",
            "Noida to Mathura",
            "Noida to Mumbai"
        ]
    },
    {
        id: 8,
        city: "Ajmer",
        img: Ajmer,
        description:
            "Hire a trusted Ajmer taxi service for quick and safe travel to nearby cities. We offer both one-way and round-trip cab bookings with fixed pricing and reliable service. Whether you're heading to Pushkar, Jaipur, or Delhi, our taxis are available round the clock for easy travel. Book your Ajmer taxi online today and enjoy a smooth ride.",
        popularRoutes: [
            "Ajmer to Jaipur",
            "Ajmer to Pushkar",
            "Ajmer to Delhi",
            "Ajmer to Udaipur",
            "Ajmer to Mount Abu",
            "Ajmer to Bikaner"
        ]
    },
    {
        id: 9,
        city: "Pushkar",
        img: Pushkar,
        description:
            "Looking for a convenient Pushkar taxi service? We provide one-way and round-trip cab services from Pushkar to nearby cities at reasonable rates. Ideal for tourists, families, and solo travelers, our services come with door-to-door pickup and trained drivers. Book your Pushkar cab with ease and travel without stress.",
        popularRoutes: [
            "Pushkar to Ajmer",
            "Pushkar to Jaipur",
            "Pushkar to Delhi",
            "Pushkar to Udaipur",
            "Pushkar to Jodhpur",
            "Pushkar to Bikaner"
        ]
    },
    {
        id: 10,
        city: "Ahmedabad",
        img: Ahmedabad,
        description:
            "Book trusted Ahmedabad taxi service for safe and affordable travel across Gujarat, Rajasthan, and Maharashtra. We offer one-way and round-trip taxis from Ahmedabad to cities like Mumbai, Udaipur, and Mount Abu. Whether you're traveling for work or a weekend trip, enjoy a reliable ride with trained drivers and GPS-enabled cars. Make your Ahmedabad cab booking now.",
        popularRoutes: [
            "Ahmedabad to Dwarka",
            "Ahmedabad to Mumbai",
            "Ahmedabad to Mount Abu",
            "Ahmedabad to Jaipur",
            "Ahmedabad to Pune",
            "Ahmedabad to Somnath"
        ]
    },
    {
        id: 11,
        city: "Mumbai",
        img: mumbai,
        description:
            "Travel anywhere from Mumbai with our professional taxi service in Mumbai. We offer one-way and return trip taxis to Pune, Nashik, Ahmedabad, and other popular cities. With clean vehicles, courteous drivers, and fixed fares, your ride is always stress-free. Use our Mumbai cab service to explore nearby destinations with comfort and convenience.",
        popularRoutes: [
            "Mumbai to Pune",
            "Mumbai to Ahmedabad",
            "Mumbai to Udaipur",
            "Mumbai to Nashik",
            "Mumbai to Lonavala",
            "Mumbai to Jaipur"
        ]
    },
    {
        id: 12,
        city: "Chandigarh",
        img: Chandigarh,
        description:
            "Get dependable Chandigarh taxi services for your next trip. We provide one-way cabs from Chandigarh and round-trip rides to destinations like Delhi, Manali, Shimla, and more. Book your cab easily online and enjoy a relaxing journey with verified drivers. Make your Chandigarh cab booking with us for on-time and safe travel.",
        popularRoutes: [
            "Chandigarh to Delhi",
            "Chandigarh to Manali",
            "Chandigarh to Shimla",
            "Chandigarh to Amritsar",
            "Chandigarh to Jammu",
            "Chandigarh to Jaipur"
        ]
    }
]
export default TaxiServiceData